import React from "react"
import PropTypes from "prop-types"
import Alert from "./Alert"

const SimpleAlert = (props) => {
  return <Alert simple={true} {...props} />
}

SimpleAlert.propTypes = {
  style: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
}

SimpleAlert.defaultProps = {
  style: "",
  options: {},
  message: "",
  close: undefined
}

export default SimpleAlert
